import { useState, useEffect } from 'react';
import { onSnapshot, collection, query, orderBy } from 'firebase/firestore';
import { db, firestore } from '../firebase/firebase';

export function useFirestoreCollection(path, orderField = 'createdAt') {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {

	const collRef = collection(firestore, path); //collection(firestore, "debates", debateId, "messages")
	const q = query(collRef, orderBy(orderField, 'desc'));
		
    const unsubscribe = onSnapshot(q, snapshot => {
      const docs = snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
      setItems(docs);
      setLoading(false);
    }, err => {
      setError(err);
      setLoading(false);
    });

    return unsubscribe;
  }, [path, orderField]);

  return { items, loading, error };
}
